export default __webpack_public_path__ + "static/media/photo--sm--keynote.680efa51.jpg";